import module from './module';
import { Feature } from '@common-stack/client-react';

try {
    require('./registry');

} catch (err) {
    console.error('err when registering');
    console.error(err);
}
export * from './services';
export * from './constants';
export * from './components';
export * from './graphql/resolvers/notification/notification-resolver';

export default new Feature(module);

export * from './generatedGraphql';
